/** @jsx jsx */
import { Box, Flex } from "@eworkit/iris";
import { UnreadIndicator, UnreadNotificationsStatus } from "@eworkit/messenger";
import { FC, memo, useContext } from "react";
import { useTranslation } from "react-i18next";
import { jsx, ThemeUICSSObject } from "theme-ui";

import { ConsultantProfileContext } from "@/components/User";
import { router } from "@/views/router";

import { RouteNavItem } from "../components/RouteNavItem";

export interface INotificationsRouteNavItemProps {
  onClick?: () => void;
}

const unreadIndicatorStyles: ThemeUICSSObject = {
  width: 10,
  height: 10,
};

export const NotificationsRouteNavItem: FC<INotificationsRouteNavItemProps> = memo(({ onClick }) => {
  const { t } = useTranslation("session");
  const { currentCompany } = useContext(ConsultantProfileContext);

  const notificationsRoute = router.get("notifications");

  return (
    <UnreadNotificationsStatus>
      {(_, unreadNotificationsStatus) => (
        <Box sx={{ position: "relative" }}>
          <RouteNavItem
            variant="icon"
            icon="bell"
            iconActive="bell_fill"
            text={t("COMPONENTS.TOPBAR.BUTTON_MESSAGE_CENTER")}
            path={notificationsRoute.path}
            exact={false}
            testName={notificationsRoute.testName}
            onClick={onClick}
          />

          {(unreadNotificationsStatus.includes(currentCompany?.guid || null) ||
            (unreadNotificationsStatus.includes(null) && !currentCompany)) && (
            <Flex
              justifyContent="center"
              alignItems="center"
              sx={{ position: "absolute", width: 20, height: 20, top: 7, right: 7 }}>
              <UnreadIndicator styles={unreadIndicatorStyles} />
            </Flex>
          )}
        </Box>
      )}
    </UnreadNotificationsStatus>
  );
});
